module.exports = __webpack_public_path__ + "img/Forum.f7f761fb.svg";